import site from 'shared/utils/site'

// 勤務形態選択肢

//介護・保育
const kaigoWorkShiftChoices = [
    { label: 'フル常勤', value: 'フル常勤' },
    { label: '日勤常勤', value: '日勤常勤' },
    { label: '夜勤常勤', value: '夜勤常勤' },
    { label: '日勤パート', value: '日勤パート' },
    { label: '夜勤バイト', value: '夜勤バイト' },
    { label: 'その他', value: 'その他' },
]

//看護・POS・技師
const kangoWorkShiftChoices = [
    { label: 'フル常勤', value: 'フル常勤' },
    { label: '日勤常勤', value: '日勤常勤' },
    { label: '夜勤常勤', value: '夜勤常勤' },
    { label: '日勤パート', value: '日勤パート' },
    { label: 'フルタイムパート', value: 'フルパート' },
    { label: '夜勤バイト', value: '夜勤バイト' },
    { label: 'その他', value: 'その他' },
]

//栄養士
const eiyoushiWorkShiftChoices = [
    { label: '常勤（日勤のみ）', value: '日勤常勤' },
    { label: '常勤（夜勤あり）', value: 'フル常勤' },
    { label: '常勤（夜勤のみ）', value: '夜勤常勤' },
    { label: '日勤パート', value: '日勤パート' },
    { label: 'フルタイムパート', value: 'フルパート' },
    { label: '夜勤パート', value: '夜勤バイト' },
]

// デンタル
const dentalWorkShiftChoices = [
    { label: '常勤（日勤のみ）', value: '日勤常勤' },
    { label: '日勤パート', value: '日勤パート' },
    { label: 'フルタイムパート', value: 'フルパート' },
]

export const workShiftChoices = site.isKaigo()
    ? kaigoWorkShiftChoices
    : site.isHoiku()
    ? kaigoWorkShiftChoices
    : site.isKango()
    ? kangoWorkShiftChoices
    : site.isPos()
    ? kangoWorkShiftChoices
    : site.isGishi()
    ? kangoWorkShiftChoices
    : site.isEiyoushi()
    ? eiyoushiWorkShiftChoices
    : site.isDental()
    ? dentalWorkShiftChoices
    : null
